import { categoryMeta } from '@/mocks/animeData';

export default function CategorySection() {
  return (
    <section id="category" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
            <i className="ri-focus-3-line"></i>
            心动口味分类
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">按你的心动口味挑选</h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            每一部甜番都被分进最贴切的口味分区，想磕糖、想治愈、想体会拉扯，都能一步到位。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categoryMeta.map((c) => (
            <a
              key={c.key}
              href="#recommend"
              className="group rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 hover:border-primary-200 hover:bg-background-50 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="px-2 py-1 text-xs text-secondary-900 bg-secondary-100 rounded-full">{c.count} 部</span>
              </div>
              <h3 className="mt-4 font-heading text-lg md:text-xl text-foreground-950">{c.label}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 group-hover:text-primary-700">
                去挑选
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}